//Modal logic
const openModalBtn = document.getElementById('open-modal');
const modal = document.getElementById('overlay');
const nextPageBtn = document.getElementById('next-page');
const backBtn = document.getElementById('back-button');
const modalContents = document.querySelectorAll('.modal-content');
const collectionSelect = document.getElementById('collection-select');
const productSelect = document.getElementById('product-select');
const projectSizeInput = document.getElementById('project-size');
const projectTypeSelect = document.getElementById('project-type');
const modalCloseBtn = document.querySelector('#modal .close');
const themeHeader = document.getElementById('shopify-section-header')
const radioInputs = document.querySelectorAll('input[name="show-results"]');
const ctProductResult = document.getElementById('result-product');


let originalProductOptions = null;
let originalProjectTypeOptions = null;
let collectionSelectChanged = false;

function updateProductSelect() {
  const collectionHandle = collectionSelect.value;
  const options = originalProductOptions || (originalProductOptions = Array.from(productSelect.querySelectorAll('option')));
  const defaultOption = productSelect.querySelector('option:first-child');

  // Remove all options except for the default option
  while (productSelect.options.length > 1) {
    productSelect.remove(1);
  }

  // Add the options back in based on the selected collection
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (option.getAttribute('data-collection') === collectionHandle && !option.hasAttribute('selected')) {
      productSelect.add(option.cloneNode(true));
    }
  }

  productSelect.disabled = false;
  productSelect.value = '';
  projectTypeSelect.disabled = true;
  nextPageBtn.disabled = true;
  projectSizeInput.value = '';
  collectionSelectChanged = true;
}

function updateProjectTypeSelect() {
  const productHandle = productSelect.value;
  const options = originalProjectTypeOptions || (originalProjectTypeOptions = Array.from(projectTypeSelect.querySelectorAll('option')));
  const defaultOption = projectTypeSelect.querySelector('option:first-child');

  // Remove all options except for the default option
  while (projectTypeSelect.options.length > 1) {
    projectTypeSelect.remove(1);
  }

  // Add the options back in based on the selected product
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (option.getAttribute('data-product') === productHandle && !option.hasAttribute('selected')) {
      const clonedOption = option.cloneNode(true);
      let optionExists = false;
      // Check if an option with the same innerHTML already exists
      for (let j = 0; j < projectTypeSelect.options.length; j++) {
        const existingOption = projectTypeSelect.options[j];
        if (existingOption.innerHTML === clonedOption.innerHTML) {
          optionExists = true;
          break;
        }
      }
      // If the option doesn't already exist, add it to the select element
      if (!optionExists) {
        projectTypeSelect.add(clonedOption);
      }
    }
  }  

  projectTypeSelect.value = '';
  projectTypeSelect.disabled = collectionSelectChanged;
  nextPageBtn.disabled = true;
}


function resetModal() {
  collectionSelect.value = '';
  productSelect.value = '';
  productSelect.disabled = true;
  projectSizeInput.value = '';
  projectSizeInput.disabled = true;
  projectTypeSelect.value = '';
  projectTypeSelect.disabled = true;
  const modalContents = document.querySelectorAll('.modal-content');
  for (let i = 0; i < modalContents.length; i++) {
    if (i == 0) {
      modalContents[i].classList.remove('hidden');
    } else {
      modalContents[i].classList.add('hidden');
    }
  }
  nextPageBtn.disabled = true;
}

function closeModal() {
  modal.style.display = 'none';
  resetModal();
  document.body.classList.remove('no-scroll');
}

openModalBtn.addEventListener('click', function(event) {
  event.preventDefault();
  modal.style.display = 'block';
  document.body.classList.add('no-scroll');
});

nextPageBtn.addEventListener('click', function() {
  const currentContent = document.querySelector('.modal-content:not(.hidden)');
  const nextContent = currentContent.nextElementSibling;
  currentContent.classList.add('hidden');
  setTimeout(() => {
    nextContent.classList.remove('hidden');
  }, 700);
});

backBtn.addEventListener('click', function() {
  const currentContent = document.querySelector('.modal-content:not(.hidden)');
  const prevContent = currentContent.previousElementSibling;
  
  currentContent.classList.add('hidden');
  setTimeout(() => {
    prevContent.classList.remove('hidden');
    resetModal();
  }, 700);
});

collectionSelect.addEventListener('change', function() {
  updateProductSelect();
});

productSelect.addEventListener('change', function(event) {
  projectSizeInput.disabled = false;
  ctProductResult.innerHTML = event.target.value;
  updateProjectTypeSelect();
});

projectSizeInput.addEventListener('input', function() {
  projectTypeSelect.disabled = false;
  nextPageBtn.disabled = true;
});

projectTypeSelect.addEventListener('change', function() {
  nextPageBtn.disabled = false;
});

overlay.addEventListener('click', function(event) {
  if (event.target === overlay) {
    closeModal();
  }
});

modalCloseBtn.addEventListener('click', function() {
  closeModal();
});

radioInputs.forEach((radioInput) => {
  radioInput.addEventListener('change', (event) => {
    const newPlaceholder = event.target.value === 'gallons' ? 'Square Feet' : 'Square Meters';
  projectSizeInput.setAttribute('placeholder', newPlaceholder);
  });
});

//calculation logic
const resultUnit = document.getElementById('ct-result-unit')

function calculatePaintNeeded() {
  const coverageAttr = productSelect.options[productSelect.selectedIndex].getAttribute('data-coverage');
  const coverage = parseFloat(coverageAttr);
  const projectSize = parseFloat(projectSizeInput.value);
  const projectType = parseFloat(projectTypeSelect.value);

  let paintNeeded = (coverage * projectSize * projectType).toFixed(2);

  if (showResultsInLiters()) {
    paintNeeded = (paintNeeded / 0.264172052).toFixed(2);
    resultUnit.innerHTML = 'Liters'
  } else {
    paintNeeded = paintNeeded;
    resultUnit.innerHTML = 'Gallons'
  }
  return paintNeeded;
}

function showResultsInLiters() {
  const radio = document.querySelector('input[name="show-results"]:checked');
  const value = radio.value;
  return value === 'liters';
}


const calculateBtn = document.getElementById('next-page');
const ctResult = document.getElementById('ct-result');


calculateBtn.addEventListener('click', function() {
  const paintNeeded = calculatePaintNeeded();

  setTimeout(function() {
    countUpAnimation(ctResult, paintNeeded);
  }, 1000); // 1000 milliseconds (1 second) delay before starting animation
});

function countUpAnimation(element, endValue) {
  const duration = 2000; // 3 seconds
  const range = endValue;
  let current = 0;
  const increment = endValue / duration * 10;

  const interval = setInterval(function() {
    current += increment;
    element.textContent = current.toFixed(0);
    if (current >= range) {
      clearInterval(interval);
      element.textContent = endValue.toFixed(0);
    }
  }, 5); // 10 milliseconds interval for smoother animation
}
